import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { translateNumber } from 'flow/utils/browser-utils';
import { useAppSelector } from 'flow/hooks/useRedux';
import { RouteKey, routes } from 'flow/types/routes';
import { QueueKey } from 'flow/types/EntityKeys';
import {
    makeSelectNumberAgentsLoggedInToQueue,
    selectQueueMembersCount,
} from 'flow/selectors/queue-selectors';
import useAppContext from 'flow/hooks/useAppContext';
import MemberCountDescription from '../MemberCountDescription';
import RouteLink from 'flow/components/ui-components/RouteLink';
import PbxMenuIcon from 'flow/components/pbx/PbxMenuIcon';

interface Props {
    queueKey: QueueKey;
    routeKey?: RouteKey;
}

const QueueMembers = ({
    queueKey,
    routeKey = 'pbx.queues.queueKey.members',
}: Props) => {
    const { i18next } = useAppContext();
    const selectAgentsLoggedInToQueueCount = useMemo(
        makeSelectNumberAgentsLoggedInToQueue,
        [],
    );
    const membersLoggedInToQueueCount = useAppSelector((state) =>
        selectAgentsLoggedInToQueueCount(state, queueKey),
    );
    const membersCount = useAppSelector((state) =>
        selectQueueMembersCount(state, queueKey),
    );

    return (
        <RouteLink
            to={generatePath(routes[routeKey], {
                queueKey,
            })}
            description={
                <MemberCountDescription
                    loggedInMembers={translateNumber(
                        membersLoggedInToQueueCount || 0,
                    )}
                    totalMembers={translateNumber(membersCount || 0)}
                />
            }
        >
            <PbxMenuIcon iconKey="headset" />
            <div>{i18next.t('Queue.HandleMembers.Title')}</div>
        </RouteLink>
    );
};

export default QueueMembers;
